import { useFeatureFlag } from '@src/hooks/useFeatureFlag';
import type { HistoricalFundingRatePanelConfig } from '@src/types/LayoutConfig';
import { useCallback } from 'react';
import { Panel } from '../../../../Layout/Components/Panel';
import type { LayoutPanelProps } from '../../../types';
import { HistoricalFundingRateModule } from './HistoricalFundingRateModule';

export function HistoricalFundingRatePanel({ api, params }: LayoutPanelProps<HistoricalFundingRatePanelConfig>) {
  const { enableSignals } = useFeatureFlag();

  const handleParamsChange = useCallback(
    (partial: Partial<HistoricalFundingRatePanelConfig>) => api.updateParameters(partial),
    [api]
  );

  if (!enableSignals) {
    return null;
  }

  return (
    <Panel
      panelApi={api}
      position="relative"
      display="flex"
      flexDirection="column"
      overflow="hidden"
      data-testid="historical-funding-rate-panel"
    >
      <HistoricalFundingRateModule params={params} onParamsChange={handleParamsChange} />
    </Panel>
  );
}
